export interface QueryItem {
    id: string;
    identifier: string;
    priority: number;
    sql: string;
}

export interface PreviewOutdatedInput {
    state: { isLoading: boolean; previewedSql: string | null } | undefined;
    currentSql: string;
}

export const isPreviewOutdated = ({ state, currentSql }: PreviewOutdatedInput): boolean => {
    if (!state) return false;
    if (state.isLoading) return false;
    if (state.previewedSql === null) return false;
    return state.previewedSql !== currentSql;
};

export const createNewQuery = (
    queries: QueryItem[],
    nextCounter: number
): { query: QueryItem; nextCounter: number } => {
    const existingIdentifiers = new Set(queries.map(q => q.identifier));
    let candidate = Math.max(1, nextCounter);
    while (existingIdentifiers.has(`QUERY${candidate}`)) {
        candidate += 1;
    }
    const maxPriority = queries.reduce((max, q) => Math.max(max, q.priority), 0);
    return {
        query: {
            id: `query-${Date.now()}`,
            identifier: `QUERY${candidate}`,
            priority: maxPriority + 1,
            sql: ""
        },
        nextCounter: candidate + 1
    };
};
